import React, {useEffect, useRef, useState} from "react";
import Spinner from "reactjs-simple-spinner";
import Form from "react-validation/build/form";
import logo from "../../assets/images/logo.jpg";
import Input from "react-validation/build/input";
import {Link} from "react-router-dom";
import CheckButton from "react-validation/build/button";
import {makeStyles} from "@material-ui/core/styles";
import UserService from "../../services/UserService";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

const required = (value) => {
    if (!value) {
        return (
            <div className="error">
                This field is required!
            </div>
        );
    }
};

const ChangePassword = (props) => {
    const form = useRef();
    const checkBtn = useRef();
    const [current_password, setCurrentPassword] = useState('');
    const [new_password, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        setLoading(false);
        let user = JSON.parse(localStorage.getItem('user'))
        setEmail(user.email)
        setMessage('');
    }, []);

    const classes = useStyles();


    const handleChangePassword = (e) => {
        setLoading(true);
        e.preventDefault();
        let data = {
            'email': email,
            'current_password': current_password,
            'new_password': new_password
        }

        console.log(data);

        UserService.changePassword(data)
            .then(res => {
                console.log("response: ", res.response)
                if (res.status === 200) {
                    console.log(res);
                    localStorage.setItem("user", JSON.stringify(res.data.user));
                    localStorage.setItem("token", JSON.stringify(res.data.token));
                    localStorage.setItem("roles", JSON.stringify(res.data.user.roles))
                    localStorage.setItem("isLoggedIn", JSON.stringify(true));
                    props.history.push("/dashboard");
                } else if (res.status == '400') {
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                } else {
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                }

            }).catch(err => {
            console.log("error: ", err.response);
            setLoading(false);
            toast.warning('Operation Failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        })
    }


    const onChangeNewPassword = (e) => {
        setNewPassword(e.target.value);
    }
    const onChangeCurrentPassword = (e) => {
        setCurrentPassword(e.target.value);
    }

    return (
        <>

            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Please wait....."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && (
                <div>

                    <div className="container" style={{marginTop: 100}}>
                        <ToastContainer
                            position="top-center"
                            autoClose={2000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                        <div className="row">
                            <div className="col-lg-8 col-md-6 ml-auto mr-auto">
                                <div className="card card-login"
                                >
                                    <Form onSubmit={handleChangePassword} ref={form}
                                          className="form container p-2" id="login-form"

                                    >
                                        <center>
                                            <p className="mt-5"><a href="#" className="logo2"/></p>
                                            <img src={logo} width={150} alt="logo"/>
                                            <h3>Change Password On First Login</h3>
                                        </center>
                                        <div className="card-body ml-5 mr-auto">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                 <span className="input-group-text text-primary">
                                                  <i className="fa fa-envelope"/> &nbsp;  <span
                                                     className="text-secondary text-sm-left underline">Username</span>
                                                </span>
                                                </div>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={email}
                                                    placeholder="Username"
                                                    style={{
                                                        backgroundColor: '#f5f3f3'
                                                    }}
                                                    disabled={true}
                                                />

                                                <br/>
                                            </div>
                                            <div className="input-group">

                                                <div className="input-group-prepend">
                      <span className="input-group-text text-primary">
                       <i className="fa fa-lock"/>&nbsp;  <span className="text-secondary text-sm-left underline">Current Password</span>
                      </span>
                                                </div>
                                                <Input
                                                    type="password"
                                                    className="form-control"
                                                    autoComplete={false}
                                                    value={current_password}
                                                    onChange={onChangeCurrentPassword}
                                                    validations={[required]}
                                                /><br/>

                                            </div>

                                            <div className="input-group">
                                                <div className="input-group-prepend">
                      <span className="input-group-text text-primary">
                        <i className="fa fa-lock"/>&nbsp; <span className="text-secondary text-sm-left underline">New Password</span>
                      </span>
                                                </div>
                                                <Input
                                                    type="password"
                                                    className="form-control"
                                                    value={new_password}
                                                    onChange={onChangeNewPassword}
                                                    validations={[required]}
                                                /><br/>

                                            </div>

                                        </div>
                                        <center>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={handleChangePassword}
                                                type="submit"
                                            >
                   <span style={{fontSize: 12}}>
                  Submit&nbsp;<i className="fa fa-check"/>
                  </span>

                                            </button>
                                        </center>
                                        <hr/>
                                        <CheckButton style={{display: "none"}} ref={checkBtn}/>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ChangePassword;
